// extracted by mini-css-extract-plugin
module.exports = {"divider":"_9292T","bottomGutter":"_4430u"};